<template>
<div>
    
    <br/>
    
    <br/>
    <br/>
    <div :style="{ borderBottom: '1px solid #E9E9E9' }">
        <a-row>
            <a-col a-col span="24"  align="middle">
                <h3 style="font-weight:bold">我的创意</h3>
            </a-col>
        </a-row>
             
             
    </div><br/>
    <div>
       <a-table  pagination= false :columns="columns" :dataSource="result" >
           <span slot="action" slot-scope="text, record">
                <a href="javascript:;" @click="handleEdit(record)">编辑</a><br/>
                <a href="javascript:;" @click="handleDelete(record)">删除</a>
           </span>
       </a-table><br/>
        <a-row>
            <a-col a-col span="24"  align="middle">
                <a-button type="primary" @click="addDevice()">提交新创意</a-button>
            </a-col>
        </a-row>
    </div>
</div>

    
</template>


<style scoped>


</style>

<script>
const columns = [
        {
            title: '创意',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
        },
        {
            title: '单位',
            key: 'organization',
            dataIndex: 'organization',
            width: '20%',
            scopedSlots: { customRender: 'orgnization' },
            className: 'col-package'
        },
         {
            title: '操作',
            dataIndex: 'action',
            width:'10%',
            key: 'action',
            scopedSlots: { customRender: 'action' },
        },
        
        
 ];



export default {
  data() {
    return {
      columns,
      result:[],
      selectList:"",
      selectedRowKeys: [], 
      visible:false,
      pagination: {
                // 默认当前页，每页显示数量，总数
                current: 1, 
                pageSize: 20,
                total: 0,
                showSizeChanger: true, //可改变每页数量
                pageSizeOptions: ['20', '50', '100'],
                showTotal: total => `共 ${total} 条`,
                onChange: (current, pageSize) => this.pageChange(current, pageSize),
                onShowSizeChange: (current, pageSize) => this.pageSizeChange(current, pageSize)
                },
            rowSelection: {
                onChange: (selectedRowKeys, selectedRows) => this.onSelectChange(selectedRowKeys, selectedRows),
                onSelect: (record, selected, selectedRows) => {
                console.log(record, selected, selectedRows);
                },
                onSelectAll: (selected, selectedRows, changeRows) => {
                console.log(selected, selectedRows, changeRows);
            },
            }
    }
  },
  created:function(){
    this.getDeviceList()
  },
  methods: {
    onSelectChange (selectedRowKeys) {
      console.log('selectedRowKeys changed: ', selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys
    },
    getDeviceList(){
      let userId = "";
      let tempUrl = window.location.href;
      let arr = tempUrl.split('#');
        let url =  "/ac-manage/creation/findByOpenId?openId=" + arr[1];
        let vm = this;
        this.axios.get(url).then(response => {
            vm.result = response.data.result
            vm.pagination = response.data.result
            vm.pagination.current = response.data.result.page
        })
    },
    // onSelectChange(selectedRowKeys, selectedRows){
    //         console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
    //         for(let i = 0; i < selectedRows.length; i++){
    //           this.selectList.push(selectedRows[i].sn)
    //         }
    //     },
     onSelectChange(selectedRowKeys, selectedRows){
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
            if(selectedRows.length == 1){
                this.selectList = selectedRows[0].sn
            }
            else{
                for(let i = 0, k= selectedRows.length;i < selectedRows.length -1 ; i++){
                        this.selectList = this.selectList + selectedRows[i].sn + ',';
                }
                this.selectList = this.selectList + selectedRows[selectedRows.length -1].sn   
            }
        },
     addDevice(){
            let tempUrl = window.location.href;
            let arr = tempUrl.split('#');
            let url =  "creation-add.html#" + arr[1];
            location.href= url
                 
        },
      handleOk(){
        this.visible = false;
        window.opener = null;
        window.open("about:blank", "_top").close()
      },
      handleEdit(record){
          let tempUrl = window.location.href;
            let arr = tempUrl.split('#');
            let url =  "creation-edit.html#" + arr[1] + '#' + record.id;
            location.href= url
      },
      handleDelete(record){
                let url =  "/ac-manage/creation/delete?id="+ record.id;
                let vm = this;
                this.axios.get(url).then(response => {
                    if (response.data.errCode == "0") {
                        vm.$message.success('删除成功');
                        vm.getDeviceList();
                    } else {
                        vm.$message.error(response.data.errMsg);
                    }
                                    
                })

            },
  },
}
</script>